module.exports = __webpack_public_path__ + "static/media/zoomIn.f1f4c4ac.svg";